/*
 * The texts of the user location extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	buttons: {
		header: {
			location: 'Location',
		},
	},
	components: {
		header_location: {
			enable: 'Enable',
			disable: 'Disable',
			force_update: 'Update location now',
		},
	},
};
